<div class="cell-renderer">
  @if (outputType.name === "Scheduled Email") {
    <fa-icon [icon]="['fas', 'clock']"></fa-icon>
  }
  @if (outputType.name === "Download") {
    <fa-icon [icon]="['fas', 'download']"></fa-icon>
  }
  <div>
    {{ outputType.name }}
  </div>
</div>
